let filters = {
	reviewer: {name: 'reviewer', 'nickname': 'Reviewer', type: 'multi', options: {},selections: {}, size: 2},
	last_completed: {name: 'last_completed', 'nickname': 'Last Completed', type: 'date_range', options: {},selections: {}, size: 2},
	last_assigned: {name: 'last_assigned', 'nickname': 'Last Assigned', type: 'date_range', options: {},selections: {}, size: 2},
	lc_month: {name: 'lc_month', 'nickname': 'Last Completed month', type: 'multi', options: {},selections: {}, size: 3},
	la_month: {name: 'la_month', 'nickname': 'Last Assigned month', type: 'multi', options: {},selections: {}, size: 3},
	gc: {name: 'gc', 'nickname': 'Group Companies', type: 'multi', options: {},selections: {}, size: 6},
}

module.exports = filters